// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__zSTUo","title":"Header_title__2picm","main-image":"Header_main-image__2Q3So"};